import { render } from "./DialogFrame.vue?vue&type=template&id=10311cce&scoped=true&ts=true"
import script from "./DialogFrame.vue?vue&type=script&lang=ts"
export * from "./DialogFrame.vue?vue&type=script&lang=ts"

import "./DialogFrame.vue?vue&type=style&index=0&id=10311cce&lang=scss&scoped=true"

import exportComponent from "/root/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10311cce"]])

export default __exports__